import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import PWYWModal from '../portal/PWYWModal';

const { FiLock, FiUnlock, FiPlay, FiMusic, FiVideo, FiFileText } = FiIcons;

const typeIcon = { audio: FiMusic, video: FiVideo, stems: FiMusic, document: FiFileText };

const ExclusiveContentCard = ({ content, hasAccess, onUnlock, userId }) => {
  const [isPWYWOpen, setIsPWYWOpen] = useState(false);
  const Icon = typeIcon[content.content_type] || FiMusic;

  const handleConfirm = async (amount) => {
    return await onUnlock({ contentId: content.id, artistId: content.artist_id, amount, userId });
  };

  return (
    <>
      <div className="group relative rounded-3xl overflow-hidden border border-zinc-800 bg-zinc-900/50 hover:border-zinc-700 transition-all">
        <div className="aspect-video overflow-hidden bg-zinc-900 relative">
          {content.cover_image ? (
            <img src={content.cover_image} alt={content.title}
              className={`w-full h-full object-cover transition-all duration-700 ${hasAccess ? '' : 'grayscale blur-sm opacity-40'}`} />
          ) : (
            <div className="w-full h-full flex items-center justify-center bg-zinc-900">
              <SafeIcon icon={Icon} className="text-6xl text-zinc-700" />
            </div>
          )}

          {!hasAccess && (
            <div className="absolute inset-0 flex items-center justify-center bg-black/60 backdrop-blur-sm">
              <button onClick={() => setIsPWYWOpen(true)}
                className="px-8 py-4 bg-white text-black font-black uppercase tracking-widest text-xs rounded-full hover:scale-105 active:scale-95 transition-all flex items-center gap-3 shadow-2xl">
                <SafeIcon icon={FiLock} /> Unlock · ${content.suggested_price}
              </button>
            </div>
          )}

          {hasAccess && content.content_url && (
            <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity bg-black/40">
              <a href={content.content_url} target="_blank" rel="noreferrer"
                className="w-16 h-16 bg-white text-black rounded-full flex items-center justify-center hover:scale-110 transition-transform shadow-2xl">
                <SafeIcon icon={FiPlay} className="text-2xl ml-1" />
              </a>
            </div>
          )}
        </div>

        <div className="p-6 space-y-3">
          <div className="flex items-center justify-between gap-4">
            <h3 className="font-black text-white uppercase tracking-tight text-lg truncate">{content.title}</h3>
            {hasAccess
              ? <span className="flex items-center gap-1.5 text-green-400 text-xs font-black uppercase tracking-widest flex-shrink-0"><SafeIcon icon={FiUnlock} /> Unlocked</span>
              : <span className="text-zinc-500 text-xs font-black uppercase tracking-widest flex-shrink-0">{content.content_type}</span>
            }
          </div>
          {content.description && (
            <p className="text-zinc-400 text-sm leading-relaxed line-clamp-2">{content.description}</p>
          )}
          <div className="flex items-center justify-between pt-2">
            <span className="text-zinc-600 text-xs font-black uppercase tracking-widest">{content.unlock_count || 0} fans unlocked</span>
            {!hasAccess && (
              <button onClick={() => setIsPWYWOpen(true)}
                className="text-xs font-black uppercase tracking-widest text-blue-400 hover:text-blue-300 transition-colors">
                Support →
              </button>
            )}
          </div>
        </div>
      </div>

      <PWYWModal isOpen={isPWYWOpen} onClose={() => setIsPWYWOpen(false)}
        onConfirm={handleConfirm} itemTitle={content.title}
        suggestedPrice={content.suggested_price} />
    </>
  );
};

export default ExclusiveContentCard;